import React from 'react';
import { Typography, Tabs } from 'antd';
import { SettingOutlined, TeamOutlined, UserOutlined, FileTextOutlined, SafetyOutlined } from '@ant-design/icons';
import UserLimits from '../components/account/UserLimits';
import UserManagement from '../components/account/UserManagement';
import SystemSettings from '../components/account/SystemSettings';
import DomainMigration from '../components/account/DomainMigration';
import Omega from '../components/account/Omega';
import DocumentationManager from '../components/account/DocumentationManager';
import PrivacyManager from '../components/account/PrivacyManager';

const { Title } = Typography;

const Account = () => {
  const tabItems = [
    {
      key: 'limits',
      label: (
        <span className="flex items-center space-x-2">
          <TeamOutlined />
          <span>User Limits</span>
        </span>
      ),
      children: <UserLimits />
    },
    {
      key: 'users',
      label: (
        <span className="flex items-center space-x-2">
          <UserOutlined />
          <span>User Management</span>
        </span>
      ),
      children: <UserManagement />
    },
    {
      key: 'migration',
      label: (
        <span className="flex items-center space-x-2">
          <UserOutlined />
          <span>Migration</span>
        </span>
      ),
      children: <DomainMigration />
    },
    {
      key: 'documentation',
      label: (
        <span className="flex items-center space-x-2">
          <FileTextOutlined />
          <span>Documentation</span>
        </span>
      ),
      children: <DocumentationManager />
    },
    {
      key: 'privacy',
      label: (
        <span className="flex items-center space-x-2">
          <SafetyOutlined />
          <span>Privacy Policy</span>
        </span>
      ),
      children: <PrivacyManager />
    },
    {
      key: 'settings',
      label: (
        <span className="flex items-center space-x-2">
          <SettingOutlined />
          <span>System Settings</span>
        </span>
      ),
      children: <SystemSettings />
    },
    {
      key: 'omega',
      label: (
        <span className="flex items-center space-x-2 ">
          <SettingOutlined />
          <span>Omega Settings 🔒</span>
        </span>
      ),
      children: <Omega />
    }
  ];

  return (
    <div className="p-6">
      {/* Page Header */}
      <div className="mb-6">
        <div className="flex items-center space-x-3 mb-2">
          <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-blue-600 rounded-full flex items-center justify-center">
            <SettingOutlined className="text-xl text-white" />
          </div>
          <div>
            <Title level={2} className="mb-0">Account Management</Title>
            <p className="text-gray-600 mb-0">System administration and user management</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <Tabs 
        defaultActiveKey="limits"
        size="large"
        items={tabItems}
      />
    </div>
  );
};

export default Account;